import i18n from "@/i18n";

export const readFileAsText = async (file: File): Promise<string> => {
  if (typeof file.text === "function") {
    return file.text();
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === "string") {
        resolve(reader.result);
      } else {
        reject(new Error(i18n.t("externalRegister.import.file.errors.noText", { defaultValue: "CSV file did not produce text." })));
      }
    };
    reader.onerror = () => reject(reader.error ?? new Error(i18n.t("externalRegister.import.file.errors.readFailed", { defaultValue: "CSV file could not be read." })));
    reader.readAsText(file);
  });
};
